import PropTypes from 'prop-types';
import { ReactComponent as WarningSVG } from '../../icons/warning.svg';
import './teleconsultation_warning.scss';

const TeleconsultationWarning = ({ cancelledBy, eventCancellationReason }) => {
  return (
    <div
      className="treatment-info-wrapper w-100 mih15 flex flex-row pa4 mt5 mb10"
      style={{ gap: '20px' }}
    >
      <div className="flex-auto flex-grow-0" style={{ paddingTop: '8px' }}>
        <WarningSVG className="svg-warning" />
      </div>
      <div className="flex-auto flex flex-column justify-between pa1">
        <div className="fw5 red-d3">
          This teleconsultation was canceled by {cancelledBy} via Calendly.
        </div>
        {eventCancellationReason && (
          <div className="red-d1 fw3">
            {' '}
            Cancellation reason: {''}
            {eventCancellationReason}
          </div>
        )}
      </div>
    </div>
  );
};

TeleconsultationWarning.propTypes = {
  cancelledBy: PropTypes.string,
  eventCancellationReason: PropTypes.string,
};

export default TeleconsultationWarning;
